var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartWithCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 123,
    viewBox: "0 0 122 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0013 45.0001C50.0013 45.0001 58.1111 45.0001 67.8224 45.0001C77.5337 45.0001 85.4062 45.0001 85.4062 45.0001C85.4062 54.7114 77.5337 61.0933 67.8224 61.0933C58.1111 61.0933 50.0013 54.7114 50.0013 45.0001Z",
    fill: "#00A3E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9393_27315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.3616 74.3203L98.5206 40.843L94.7003 39.5689L84.4591 70.2947H47.1051L33.0154 28.0254H21.5V32.051H30.1129L43.4981 72.2028L34.5048 92.4357H89.936V88.4101H40.7003L46.9622 74.3203H87.3616Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6917 102.5C53.915 102.5 55.7173 100.697 55.7173 98.4739C55.7173 96.2506 53.915 94.4482 51.6917 94.4482C49.4684 94.4482 47.666 96.2506 47.666 98.4739C47.666 100.697 49.4684 102.5 51.6917 102.5Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.846 102.5C78.0693 102.5 79.8716 100.697 79.8716 98.4739C79.8716 96.2506 78.0693 94.4482 75.846 94.4482C73.6227 94.4482 71.8203 96.2506 71.8203 98.4739C71.8203 100.697 73.6227 102.5 75.846 102.5Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3952 29.5497L62.9348 38.0894L54.3952 46.629L57.2417 49.4756L65.7814 40.9359L74.3211 49.4756L77.1676 46.629L68.628 38.0894L77.1676 29.5497L74.3211 26.7031L65.7814 35.2428L57.2417 26.7031L54.3952 29.5497Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9393_27315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0.5 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartWithCross);
export default __webpack_public_path__ + "static/media/cart-with-cross.bebc42746f2bd0d5643d93ffdbfc9026.svg";
export { ForwardRef as ReactComponent };